import type { SignupProgramOption } from '@galapagos/shared/registration';

/**
 * The sub-type answers in a selection, keyed by answer name: for every
 * selected program whose option names one, the answer value of its chosen
 * sub-option. The names and values come from the served options and are
 * matched by equality only, so the client never learns which program or
 * sub-type they stand for (ADR-015).
 */
export function selectedSubOptionAnswers(
  options: readonly SignupProgramOption[],
  selection: readonly string[] | null,
): Record<string, string> {
  if (!selection?.length) return {};
  const answers: Record<string, string> = {};
  for (const option of options) {
    const answerName = option.subOptionAnswerName;
    if (answerName === undefined || !selection.includes(option.programKey)) continue;
    const answerValue = option.subOptions?.find(
      (sub) => sub.answerValue !== undefined && selection.includes(sub.value),
    )?.answerValue;
    if (answerValue !== undefined) answers[answerName] = answerValue;
  }
  return answers;
}
